'use strict';

(function () {
  'use strict';

  angular.module('youth').controller('ConfirmModalCtrl', ConfirmModalCtrl);

  ConfirmModalCtrl.$inject = ['$log', 'heading', 'body', 'close'];

  /* @ngInject */
  function ConfirmModalCtrl($log, heading, body, close) {
    var $ctrl = this;
    $ctrl.title = 'ConfirmModalCtrl';

    $ctrl.modalTitle = heading;
    $ctrl.modalMessage = body;

    activate();

    $ctrl.closeModal = function (response) {
      // 200ms pause to let ngAnimate hide the modal.
      close(response, 200);
    };

    ////////////////

    function activate() {
      $log.debug($ctrl.title + ' control activate');
    }
  }
})();